/* ==================================================
   SHOPIFY CHAT IMAGE OVERRIDE - VORSTEINER SUPPORT
   ================================================== */
(function() {
  const VORSTEINER_SUPPORT_URL = 'https://cdn.shopify.com/s/files/1/0428/2692/4184/files/vorsteiner-product-chat.png';
  const SHADOW_STYLE_ID = 'vorsteiner-support-chat-styles';

  function getAgentElement() {
    return document.querySelector('shopify-chat, shopify-agent');
  }

  function getAgentRoot(agent) {
    return agent && agent.shadowRoot ? agent.shadowRoot : null;
  }

  function buildSupportStyles() {
    return (
      ':host(:not([open])) .activator {' +
        'background-image: url("' + VORSTEINER_SUPPORT_URL + '") !important;' +
        'background-size: 105% !important;' +
        'background-repeat: no-repeat !important;' +
        'background-position: center center !important;' +
        'background-color: #bfe9f8 !important;' +
        'border-radius: 50% !important;' +
        'width: 60px !important;' +
        'height: 60px !important;' +
        'min-width: 60px !important;' +
        'min-height: 60px !important;' +
        'padding: 0 !important;' +
        'display: flex !important;' +
        'align-items: center !important;' +
        'justify-content: center !important;' +
        'position: relative !important;' +
        'overflow: visible !important;' +
        'opacity: 1 !important;' +
        'visibility: visible !important;' +
        'scale: 1 !important;' +
        'text-indent: -9999px !important;' +
        'color: transparent !important;' +
      '}' +
      ':host(:not([open])) .activator__icon,' +
      ':host(:not([open])) shopify-chat-icon {' +
        'display: none !important;' +
        'visibility: hidden !important;' +
        'opacity: 0 !important;' +
      '}' +
      ':host(:not([open])) .activator__label {' +
        'display: none !important;' +
      '}' +
      ':host(:not([open])) .activator__indicator {' +
        'display: none !important;' +
      '}' +
      ':host(:not([open])) .activator::after {' +
        'content: "";' +
        'position: absolute;' +
        'top: 1px;' +
        'right: 1px;' +
        'width: 10px;' +
        'height: 10px;' +
        'border-radius: 50%;' +
        'background-color: #e53935;' +
        'border: 2px solid #ffffff;' +
        'box-shadow: 0 1px 3px rgba(0, 0, 0, 0.28);' +
        'z-index: 1002;' +
        'pointer-events: none;' +
      '}'
    );
  }

  function injectSupportStyles(root) {
    if (!root) {
      return false;
    }

    let style = root.getElementById(SHADOW_STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = SHADOW_STYLE_ID;
      root.appendChild(style);
    }

    const css = buildSupportStyles();
    if (style.textContent !== css) {
      style.textContent = css;
    }
    return true;
  }

  function getAgentRuntime(agent) {
    const root = getAgentRoot(agent);
    return root ? root.querySelector('shopify-agent-runtime') : null;
  }

  function ensureSupportStyles(agent) {
    const root = getAgentRoot(agent);
    if (!root) {
      return false;
    }

    injectSupportStyles(root);

    const runtime = getAgentRuntime(agent);
    if (runtime && runtime.shadowRoot) {
      injectSupportStyles(runtime.shadowRoot);
      watchRuntimeShadow(runtime);
    }

    agent.classList.toggle('vorsteiner-support-enabled', !agent.hasAttribute('open'));
    return true;
  }

  function watchRuntimeShadow(runtime) {
    if (!runtime || runtime.__vorsteinerRuntimeWatched || !runtime.shadowRoot) {
      return;
    }

    runtime.__vorsteinerRuntimeWatched = true;

    const runtimeObserver = new MutationObserver(function() {
      if (!runtime.shadowRoot || runtime.shadowRoot.getElementById(SHADOW_STYLE_ID)) {
        return;
      }
      syncChatActivatorState();
    });

    runtimeObserver.observe(runtime.shadowRoot, {
      childList: true
    });
  }

  function setAgentZIndex() {
    const agent = getAgentElement();
    if (!agent) {
      return;
    }

    const zIndex = agent.hasAttribute('open') ? '2147483647' : '9999';
    agent.style.setProperty('z-index', zIndex, 'important');
    agent.style.removeProperty('position');
  }

  function syncChatActivatorState() {
    const agent = getAgentElement();
    if (!agent) {
      return false;
    }

    agent.classList.toggle('vorsteiner-support-enabled', !agent.hasAttribute('open'));
    setAgentZIndex();
    return ensureSupportStyles(agent);
  }

  function watchAgentState(agent) {
    if (!agent || agent.__vorsteinerAgentWatched) {
      return;
    }

    agent.__vorsteinerAgentWatched = true;

    const stateObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type !== 'attributes') {
          return;
        }

        if (mutation.attributeName === 'open' || mutation.attributeName === 'shell-ready') {
          syncChatActivatorState();
        }
      });
    });

    stateObserver.observe(agent, {
      attributes: true,
      attributeFilter: ['open', 'shell-ready']
    });

    watchRuntimeShadow(getAgentRuntime(agent));

    const root = getAgentRoot(agent);
    if (root && !root.__vorsteinerAgentRootWatched) {
      root.__vorsteinerAgentRootWatched = true;

      const rootObserver = new MutationObserver(function() {
        syncChatActivatorState();
      });

      rootObserver.observe(root, {
        childList: true,
        subtree: true
      });
    }
  }

  function setupChatSupport(retryCount) {
    retryCount = retryCount || 0;
    const agent = getAgentElement();
    if (!agent) {
      if (retryCount < 8) {
        setTimeout(function() {
          setupChatSupport(retryCount + 1);
        }, retryCount < 3 ? 500 : 1000);
      }
      return;
    }

    setAgentZIndex();
    syncChatActivatorState();
    watchAgentState(agent);

    const runtime = getAgentRuntime(agent);
    if (retryCount < 12 && (!getAgentRoot(agent) || !runtime || !runtime.shadowRoot)) {
      setTimeout(function() {
        setupChatSupport(retryCount + 1);
      }, retryCount < 3 ? 500 : 1000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setupChatSupport(0);
    });
  } else {
    setupChatSupport(0);
  }

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) {
          return;
        }

        if (
          node.tagName === 'SHOPIFY-CHAT' ||
          node.tagName === 'SHOPIFY-AGENT' ||
          (node.querySelector && node.querySelector('shopify-chat, shopify-agent'))
        ) {
          setTimeout(function() {
            setupChatSupport(0);
          }, 500);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

/* ==================================================
   EASYSEARCH DRAWER - ENSURE MAIN MENU CLOSE BUTTON STAYS ACCESSIBLE
   ================================================== */

(function() {
  function ensureMainMenuCloseButtonAccessible() {
    const mainMenuDrawer = document.getElementById('header-sidebar-menu');
    const easysearchDrawer = document.getElementById('easysearch-drawer');
    
    if (!mainMenuDrawer || !easysearchDrawer) return;
    
    const isMainMenuOpen = mainMenuDrawer.hasAttribute('open');
    const isEasySearchOpen = easysearchDrawer.hasAttribute('open');
    const isMobile = window.matchMedia('(max-width: 699px)').matches;
    
    if (!isMobile) return; // Only handle mobile layering
    
    // EasySearch should always be on top when open
    if (isEasySearchOpen) {
      easysearchDrawer.style.zIndex = '10000';
      
      if (easysearchDrawer.shadowRoot) {
        const easysearchOverlay = easysearchDrawer.shadowRoot.querySelector('[part="overlay"]');
        const easysearchContent = easysearchDrawer.shadowRoot.querySelector('[part="content"]');
        const outsideCloseButton = easysearchDrawer.shadowRoot.querySelector('[part="outside-close-button"]');
        
        if (easysearchOverlay) {
          easysearchOverlay.style.zIndex = '9999';
          easysearchOverlay.style.pointerEvents = 'auto';
        }
        if (easysearchContent) {
          easysearchContent.style.zIndex = '10000';
        }
        
        // Hide outside-close-button when main menu is also open
        if (outsideCloseButton) {
          if (isMainMenuOpen) {
            outsideCloseButton.style.display = 'none';
            outsideCloseButton.style.visibility = 'hidden';
            outsideCloseButton.style.opacity = '0';
            outsideCloseButton.style.pointerEvents = 'none';
          } else {
            outsideCloseButton.style.display = 'grid';
            outsideCloseButton.style.visibility = 'visible';
            outsideCloseButton.style.opacity = '1';
            outsideCloseButton.style.pointerEvents = 'auto';
            outsideCloseButton.style.zIndex = '10001';
            outsideCloseButton.style.position = 'fixed';
            outsideCloseButton.style.top = '20px';
            outsideCloseButton.style.right = '20px';
            outsideCloseButton.style.left = 'auto';
            outsideCloseButton.style.transform = 'none';
          }
        }
      }
    }
    
    // Main menu should be below EasySearch when both are open
    if (isMainMenuOpen) {
      if (isEasySearchOpen) {
        mainMenuDrawer.style.zIndex = '9998';
      } else {
        mainMenuDrawer.style.zIndex = '';
      }
      
      // Ensure main menu close button is accessible
      const mainMenuCloseButton = mainMenuDrawer.querySelector('[is="close-button"]');
      if (mainMenuCloseButton) {
        mainMenuCloseButton.style.zIndex = isEasySearchOpen ? '9999' : '';
        mainMenuCloseButton.style.position = 'relative';
        mainMenuCloseButton.style.pointerEvents = 'auto';
      }
      
      if (mainMenuDrawer.shadowRoot) {
        const mainMenuContent = mainMenuDrawer.shadowRoot.querySelector('[part="content"]');
        const mainMenuHeader = mainMenuDrawer.shadowRoot.querySelector('[part="header"]');
        const mainMenuBody = mainMenuDrawer.shadowRoot.querySelector('[part="body"]');
        if (mainMenuContent) {
          mainMenuContent.style.zIndex = isEasySearchOpen ? '9998' : '';
          mainMenuContent.style.pointerEvents = 'auto';
        }
        if (mainMenuHeader) {
          mainMenuHeader.style.zIndex = isEasySearchOpen ? '9998' : '';
          mainMenuHeader.style.pointerEvents = 'auto';
        }
        if (mainMenuBody) {
          mainMenuBody.style.zIndex = isEasySearchOpen ? '9998' : '';
          mainMenuBody.style.pointerEvents = 'auto';
        }
      }
    }
  }
  
  // Watch for drawer state changes
  function watchDrawerStates() {
    const mainMenuDrawer = document.getElementById('header-sidebar-menu');
    const easysearchDrawer = document.getElementById('easysearch-drawer');
    
    if (mainMenuDrawer && easysearchDrawer) {
      // Watch both drawers for open/close using MutationObserver
      const observer = new MutationObserver(function() {
        ensureMainMenuCloseButtonAccessible();
      });
      
      observer.observe(mainMenuDrawer, {
        attributes: true,
        attributeFilter: ['open']
      });
      
      observer.observe(easysearchDrawer, {
        attributes: true,
        attributeFilter: ['open']
      });
      
      // Also listen to dialog events for immediate response
      mainMenuDrawer.addEventListener('dialog:open', ensureMainMenuCloseButtonAccessible);
      mainMenuDrawer.addEventListener('dialog:close', ensureMainMenuCloseButtonAccessible);
      easysearchDrawer.addEventListener('dialog:open', ensureMainMenuCloseButtonAccessible);
      easysearchDrawer.addEventListener('dialog:close', ensureMainMenuCloseButtonAccessible);
      
      // Initial check
      ensureMainMenuCloseButtonAccessible();
    } else {
      setTimeout(watchDrawerStates, 500);
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchDrawerStates);
  } else {
    watchDrawerStates();
  }
})();

/* ==================================================
   EASYSEARCH DRAWER - ENSURE CLOSE BUTTON ONLY CLOSES EASYSEARCH
   ================================================== */

(function() {
  function ensureEasySearchCloseButtonIsolated() {
    const easysearchDrawer = document.getElementById('easysearch-drawer');
    if (!easysearchDrawer) return;
    
    // Find EasySearch's own close button (not the outside-close-button)
    const easysearchCloseButton = easysearchDrawer.querySelector('.easysearch-close-button');
    if (!easysearchCloseButton) return;
    
    // Ensure it only closes EasySearch, not main menu
    if (!easysearchCloseButton._easysearchIsolated) {
      easysearchCloseButton._easysearchIsolated = true;
      
      // Override click handler to ensure it only closes EasySearch
      easysearchCloseButton.addEventListener('click', function(e) {
        e.stopPropagation();
        
        // Only close EasySearch drawer
        if (easysearchDrawer.hasAttribute('open')) {
          easysearchDrawer.removeAttribute('open');
          easysearchDrawer.dispatchEvent(new CustomEvent('dialog:close', { bubbles: true, cancelable: true }));
          easysearchDrawer.dispatchEvent(new CustomEvent('dialog:force-close', { bubbles: true, cancelable: true }));
          
          // Also try the native close method if available
          if (typeof easysearchDrawer.close === 'function') {
            easysearchDrawer.close();
          }
        }
        
        // Prevent any other drawer from closing
        const mainMenuDrawer = document.getElementById('header-sidebar-menu');
        if (mainMenuDrawer && mainMenuDrawer.hasAttribute('open')) {
          // Don't close main menu - it should stay open
        }
      }, { passive: false });
    }
  }
  
  function initEasySearchCloseButton() {
    const easysearchDrawer = document.getElementById('easysearch-drawer');
    if (easysearchDrawer) {
      ensureEasySearchCloseButtonIsolated();
      
      // Watch for drawer opening to ensure button is set up
      const observer = new MutationObserver(function() {
        ensureEasySearchCloseButtonIsolated();
      });
      
      observer.observe(easysearchDrawer, {
        attributes: true,
        attributeFilter: ['open'],
        childList: true,
        subtree: true
      });
    } else {
      setTimeout(initEasySearchCloseButton, 500);
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEasySearchCloseButton);
  } else {
    initEasySearchCloseButton();
  }
})();

/* ==================================================
   EASYSEARCH DRAWER - FIX OUTSIDE CLOSE BUTTON ON MOBILE
   ================================================== */

(function() {
  function ensureOutsideCloseButtonWorks() {
    const drawer = document.getElementById('easysearch-drawer');
    const mainMenuDrawer = document.getElementById('header-sidebar-menu');
    if (!drawer) return;
    
    // Access shadow DOM to get the outside-close-button
    const shadowRoot = drawer.shadowRoot;
    if (!shadowRoot) return;
    
    const outsideCloseButton = shadowRoot.querySelector('[part="outside-close-button"]');
    if (!outsideCloseButton) return;
    
    const isMobile = window.matchMedia('(max-width: 699px)').matches;
    const isEasySearchOpen = drawer.hasAttribute('open');
    const isMainMenuOpen = mainMenuDrawer && mainMenuDrawer.hasAttribute('open');
    
    // Only show outside-close-button on mobile when EasySearch is open and main menu is closed
    if (isMobile && isEasySearchOpen && !isMainMenuOpen) {
      outsideCloseButton.style.display = 'grid';
      outsideCloseButton.style.visibility = 'visible';
      outsideCloseButton.style.opacity = '1';
      outsideCloseButton.style.pointerEvents = 'auto';
      outsideCloseButton.style.cursor = 'pointer';
      outsideCloseButton.style.zIndex = '10001';
      outsideCloseButton.style.width = '48px';
      outsideCloseButton.style.height = '48px';
      outsideCloseButton.style.minWidth = '48px';
      outsideCloseButton.style.minHeight = '48px';
      outsideCloseButton.style.touchAction = 'manipulation';
      outsideCloseButton.style.webkitTapHighlightColor = 'rgba(0, 0, 0, 0.1)';
      outsideCloseButton.style.position = 'fixed';
      outsideCloseButton.style.top = '20px';
      outsideCloseButton.style.right = '20px';
      outsideCloseButton.style.left = 'auto';
      outsideCloseButton.style.transform = 'none';
    } else {
      // Hide when main menu is open or EasySearch is closed
      outsideCloseButton.style.display = 'none';
      outsideCloseButton.style.visibility = 'hidden';
      outsideCloseButton.style.opacity = '0';
      outsideCloseButton.style.pointerEvents = 'none';
    }
    
    // Ensure button is clickable when visible
    if (isMobile && isEasySearchOpen && !isMainMenuOpen) {
      
      // Ensure button closes drawer when clicked/touched
      if (!outsideCloseButton._easysearchCloseHandler) {
        outsideCloseButton._easysearchCloseHandler = function(e) {
          e.stopPropagation();
          e.preventDefault();
          
          // Close the drawer
          if (drawer.hasAttribute('open')) {
            drawer.removeAttribute('open');
            
            // Dispatch close events
            drawer.dispatchEvent(new CustomEvent('dialog:close', { bubbles: true, cancelable: true }));
            drawer.dispatchEvent(new CustomEvent('dialog:force-close', { bubbles: true, cancelable: true }));
            
            // Also try the native close method if available
            if (typeof drawer.close === 'function') {
              drawer.close();
            }
          }
          
          return false;
        };
        
        // Add multiple event listeners for better mobile support
        outsideCloseButton.addEventListener('click', outsideCloseButton._easysearchCloseHandler, { passive: false });
        outsideCloseButton.addEventListener('touchend', outsideCloseButton._easysearchCloseHandler, { passive: false });
        outsideCloseButton.addEventListener('touchstart', function(e) {
          // Prevent default to avoid double-firing
          e.stopPropagation();
        }, { passive: true });
      }
    }
  }
  
  // Run when drawer is available
  function initOutsideCloseButton() {
    const drawer = document.getElementById('easysearch-drawer');
    const mainMenuDrawer = document.getElementById('header-sidebar-menu');
    
    if (drawer) {
      ensureOutsideCloseButtonWorks();
      
      // Watch for drawer opening/closing and main menu state
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
            setTimeout(ensureOutsideCloseButtonWorks, 100);
          }
        });
      });
      
      observer.observe(drawer, {
        attributes: true,
        attributeFilter: ['open']
      });
      
      // Also watch main menu state to hide button when main menu opens
      if (mainMenuDrawer) {
        observer.observe(mainMenuDrawer, {
          attributes: true,
          attributeFilter: ['open']
        });
      }
      
      // Also watch for shadow DOM changes
      if (drawer.shadowRoot) {
        const shadowObserver = new MutationObserver(function() {
          ensureOutsideCloseButtonWorks();
        });
        
        shadowObserver.observe(drawer.shadowRoot, {
          childList: true,
          subtree: true
        });
      }
    } else {
      setTimeout(initOutsideCloseButton, 500);
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOutsideCloseButton);
  } else {
    initOutsideCloseButton();
  }
})();

/* ==================================================
   EASYSEARCH DRAWER - SHOW RESULTS ONLY WHEN DRAWER IS OPEN
   ================================================== */

(function() {
  function checkIfVehicleSelected() {
    const drawer = document.getElementById('easysearch-drawer');
    if (!drawer) return false;

    const form = drawer.querySelector('#easysearch-custom-form');
    if (!form) return false;

    const selects = form.querySelectorAll('select[name="make"], select[name="year"], select[name="model"]');
    let hasValue = false;

    selects.forEach(function(select) {
      const value = (select.value || '').trim();
      const selectedOption = select.options[select.selectedIndex];
      const label = selectedOption ? (selectedOption.textContent || '').trim() : '';
      const isPlaceholder = !value || /^select\s+/i.test(value) || /^select\s+/i.test(label);
      if (!isPlaceholder) {
        hasValue = true;
      }
    });

    return hasValue;
  }
  
  function updateResultsVisibility() {
    const drawer = document.getElementById('easysearch-drawer');
    if (!drawer) return;
    
    const isOpen = drawer.hasAttribute('open');
    const idleState = document.getElementById('easysearch-idle-state');
    const loadingState = document.getElementById('easysearch-loading-state');
    const resultsContainer = document.getElementById('easysearch-results-container');
    const searchResults = document.getElementById('easysearch-search-results');
    const resultsColumn = document.querySelector('.easysearch-results-column');
    const drawerContent = document.querySelector('.easysearch-drawer-content');
    const formColumn = document.querySelector('.easysearch-form-column');
    
    // Check if a vehicle is selected
    const vehicleSelected = checkIfVehicleSelected();
    
    if (!isOpen) {
      // Completely hide drawer and all its parts when closed - remove from layout
      if (drawer) {
        drawer.style.display = 'none';
        drawer.style.visibility = 'hidden';
        drawer.style.opacity = '0';
        drawer.style.pointerEvents = 'none';
        drawer.style.width = '0';
        drawer.style.height = '0';
        drawer.style.maxWidth = '0';
        drawer.style.maxHeight = '0';
        drawer.style.position = 'fixed';
        drawer.style.top = '-9999px';
        drawer.style.left = '-9999px';
        drawer.style.right = 'auto';
        drawer.style.bottom = 'auto';
        drawer.style.padding = '0';
        drawer.style.margin = '0';
        drawer.style.zIndex = '-1';
      }
      if (resultsColumn) {
        resultsColumn.style.display = 'none';
        resultsColumn.style.visibility = 'hidden';
        resultsColumn.style.width = '0';
        resultsColumn.style.height = '0';
      }
      if (drawerContent) {
        drawerContent.style.display = 'none';
        drawerContent.style.visibility = 'hidden';
        drawerContent.style.width = '0';
        drawerContent.style.height = '0';
      }
      if (formColumn) {
        formColumn.style.display = 'none';
        formColumn.style.visibility = 'hidden';
        formColumn.style.width = '0';
        formColumn.style.height = '0';
      }
      return;
    }
    
    // Drawer is open - show it and ensure form is visible
    if (drawer) {
      drawer.style.display = '';
      drawer.style.visibility = '';
      drawer.style.opacity = '';
      drawer.style.pointerEvents = '';
      drawer.style.width = '';
      drawer.style.height = '';
      drawer.style.maxWidth = '';
      drawer.style.maxHeight = '';
      drawer.style.position = '';
      drawer.style.top = '';
      drawer.style.left = '';
      drawer.style.right = '';
      drawer.style.bottom = '';
      drawer.style.padding = '';
      drawer.style.margin = '';
      drawer.style.zIndex = '';
    }
    if (drawerContent) {
      drawerContent.style.display = 'flex';
      drawerContent.style.visibility = 'visible';
      drawerContent.style.opacity = '1';
      drawerContent.style.width = '';
      drawerContent.style.height = '';
    }
    // Always show form column when drawer is open
    if (formColumn) {
      formColumn.style.display = 'flex';
      formColumn.style.visibility = 'visible';
      formColumn.style.opacity = '1';
      formColumn.style.width = '';
      formColumn.style.height = '';
    }
    // Ensure search results wrapper is visible
    if (searchResults) {
      searchResults.style.display = 'block';
      searchResults.style.visibility = 'visible';
    }
    
    // Check if there are results to show - comprehensive check including tabs and any visible content
    const hasResults = resultsContainer && (
      resultsContainer.children.length > 0 || 
      resultsContainer.textContent.trim() !== '' ||
      resultsContainer.innerHTML.trim() !== '' ||
      resultsContainer.querySelector('.product-item') ||
      resultsContainer.querySelector('.predictive-search__item') ||
      resultsContainer.querySelector('x-tabs') ||
      resultsContainer.querySelector('.predictive-search__tabs') ||
      resultsContainer.querySelector('.predictive-search__results') ||
      resultsContainer.querySelector('.predictive-search__products')
    );
    
    // Only real result markup counts. A visible or tall column is not results,
    // otherwise the column shows, the next check treats that as content, and it hides again.
    const resultsColumnHasContent = resultsColumn && (
      resultsColumn.querySelector('.product-item') ||
      resultsColumn.querySelector('.predictive-search__item') ||
      resultsColumn.querySelector('x-tabs') ||
      resultsColumn.querySelector('.predictive-search__tabs') ||
      resultsColumn.querySelector('.predictive-search__results') ||
      resultsColumn.querySelector('.predictive-search__products') ||
      resultsColumn.querySelector('#easysearch-results-container:not(:empty)')
    );
    
    const searchResultsHasContent = searchResults && (
      searchResults.querySelector('.product-item') ||
      searchResults.querySelector('.predictive-search__item') ||
      searchResults.querySelector('x-tabs') ||
      searchResults.querySelector('.predictive-search__tabs') ||
      searchResults.querySelector('.predictive-search__results') ||
      searchResults.querySelector('.predictive-search__products')
    );
    
    // Check if tabs exist anywhere in results area - tabs = results are present
    const tabsExist = (resultsColumn && (
      resultsColumn.querySelector('x-tabs') ||
      resultsColumn.querySelector('.predictive-search__tabs') ||
      resultsColumn.querySelector('[role="tablist"]')
    )) || (searchResults && (
      searchResults.querySelector('x-tabs') ||
      searchResults.querySelector('.predictive-search__tabs') ||
      searchResults.querySelector('[role="tablist"]')
    ));
    
    const actuallyHasResults = hasResults || resultsColumnHasContent || searchResultsHasContent || tabsExist;
    
    // Check if we're in a loading state (vehicle selected but no results yet)
    const isLoading = vehicleSelected && !actuallyHasResults && resultsContainer && (
      resultsContainer.children.length === 0 || 
      resultsContainer.innerHTML.trim() === '' ||
      !resultsContainer.querySelector('x-tabs') &&
      !resultsContainer.querySelector('.predictive-search__tabs')
    );
    
    // Hide results column initially - only show when there are actual results
    if (resultsColumn) {
      if (actuallyHasResults) {
        // Show results column when there are results - clear any width/height restrictions
        resultsColumn.style.display = 'flex';
        resultsColumn.style.visibility = 'visible';
        resultsColumn.style.opacity = '1';
        resultsColumn.style.width = ''; // Clear inline width to allow CSS to control
        resultsColumn.style.height = ''; // Clear inline height to allow CSS to control
        resultsColumn.style.maxWidth = '';
        resultsColumn.style.maxHeight = '';
        resultsColumn.style.minWidth = '';
        resultsColumn.style.minHeight = '';
        
        // Show results container
        if (resultsContainer) {
          resultsContainer.style.display = 'block';
          resultsContainer.style.visibility = 'visible';
          resultsContainer.style.opacity = '1';
        }
        
        // Hide loading state when results arrive
        if (loadingState) {
          loadingState.style.display = 'none';
          loadingState.style.visibility = 'hidden';
          loadingState.style.opacity = '0';
        }
        
        // Always hide idle state when results exist - completely remove from layout
        if (idleState) {
          idleState.style.display = 'none';
          idleState.style.visibility = 'hidden';
          idleState.style.opacity = '0';
          idleState.style.height = '0';
          idleState.style.minHeight = '0';
          idleState.style.maxHeight = '0';
          idleState.style.padding = '0';
          idleState.style.margin = '0';
          idleState.style.overflow = 'hidden';
          idleState.style.position = 'absolute';
          idleState.style.top = '-9999px';
          idleState.style.left = '-9999px';
        }
      } else if (isLoading) {
        // Show loading state when vehicle is selected but results are being fetched
        resultsColumn.style.display = 'flex';
        resultsColumn.style.visibility = 'visible';
        resultsColumn.style.opacity = '1';
        resultsColumn.style.width = '';
        resultsColumn.style.height = '';
        resultsColumn.style.maxWidth = '';
        resultsColumn.style.maxHeight = '';
        resultsColumn.style.minWidth = '';
        resultsColumn.style.minHeight = '';
        
        // Show loading state
        if (loadingState) {
          loadingState.style.display = 'block';
          loadingState.style.visibility = 'visible';
          loadingState.style.opacity = '1';
        }
        
        // Hide results container while loading
        if (resultsContainer) {
          resultsContainer.style.display = 'none';
          resultsContainer.style.visibility = 'hidden';
          resultsContainer.style.opacity = '0';
        }
        
        // Hide idle state when loading
        if (idleState) {
          idleState.style.display = 'none';
          idleState.style.visibility = 'hidden';
          idleState.style.opacity = '0';
        }
      } else {
        // Hide results column when no results and not loading
        resultsColumn.style.display = 'none';
        resultsColumn.style.visibility = 'hidden';
        
        // Hide loading state when no vehicle selected
        if (loadingState) {
          loadingState.style.display = 'none';
          loadingState.style.visibility = 'hidden';
          loadingState.style.opacity = '0';
        }
        
        // Check if results container has any content (even if column is hidden)
        const containerHasContent = resultsContainer && (
          resultsContainer.children.length > 0 ||
          resultsContainer.innerHTML.trim() !== '' ||
          resultsContainer.querySelector('*')
        );
        
        // Hide idle state if vehicle is selected OR if results container has content, show if not
        if (idleState) {
          if (vehicleSelected || containerHasContent) {
            // Hide "Select a vehicle" text when a make/year/model is selected or when results exist
            idleState.style.display = 'none';
            idleState.style.visibility = 'hidden';
            idleState.style.opacity = '0';
            idleState.style.height = '0';
            idleState.style.minHeight = '0';
            idleState.style.maxHeight = '0';
            idleState.style.padding = '0';
            idleState.style.margin = '0';
            idleState.style.overflow = 'hidden';
          } else {
            // Show idle state only when no vehicle is selected and no results
            idleState.style.display = 'block';
            idleState.style.visibility = 'visible';
            idleState.style.opacity = '1';
            idleState.style.height = 'auto';
            idleState.style.minHeight = '150px';
            idleState.style.padding = '';
            idleState.style.margin = '';
            idleState.style.overflow = '';
          }
        }
        if (resultsContainer) {
          resultsContainer.style.display = 'none';
          resultsContainer.style.visibility = 'hidden';
          resultsContainer.style.opacity = '0';
        }
      }
    } else {
      // No results container - check if we should show/hide idle state
      if (idleState) {
        if (vehicleSelected) {
          // Hide "Select a vehicle" text when a make/year/model is selected
          idleState.style.display = 'none';
          idleState.style.visibility = 'hidden';
          idleState.style.opacity = '0';
          idleState.style.height = '0';
          idleState.style.minHeight = '0';
          idleState.style.maxHeight = '0';
          idleState.style.padding = '0';
          idleState.style.margin = '0';
          idleState.style.overflow = 'hidden';
        } else {
          // Show idle state only when no vehicle is selected
          idleState.style.display = 'block';
          idleState.style.visibility = 'visible';
          idleState.style.opacity = '1';
          idleState.style.height = 'auto';
          idleState.style.minHeight = '150px';
          idleState.style.padding = '';
          idleState.style.margin = '';
          idleState.style.overflow = '';
        }
      }
    }
  }
  
  // Run when drawer opens/closes
  const drawer = document.getElementById('easysearch-drawer');
  if (drawer) {
    drawer.addEventListener('dialog:open', function() {
      setTimeout(updateResultsVisibility, 100);
    });
    
    drawer.addEventListener('dialog:close', function() {
      updateResultsVisibility();
    });
    
    // Watch for drawer opening/closing via attribute changes
    const drawerObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          setTimeout(updateResultsVisibility, 100);
        }
      });
    });
    
    drawerObserver.observe(drawer, {
      attributes: true,
      attributeFilter: ['open']
    });
    
    // Initial check
    updateResultsVisibility();
  }
  
  // Watch for changes to results container content, loading state, and form selections
  const observer = new MutationObserver(function(mutations) {
    const drawer = document.getElementById('easysearch-drawer');
    if (!drawer || !drawer.hasAttribute('open')) return;
    
    let shouldUpdate = false;
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        const target = mutation.target;
        if (target.id === 'easysearch-results-container' || 
            target.id === 'easysearch-idle-state' ||
            target.id === 'easysearch-loading-state' ||
            target.classList.contains('easysearch-results-column')) {
          shouldUpdate = true;
        }
        // Check if results were added (including tabs which indicate results are present)
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (
            node.id === 'easysearch-results-container' ||
            node.id === 'easysearch-loading-state' ||
            node.classList.contains('product-item') ||
            node.classList.contains('predictive-search__item') ||
            node.tagName === 'X-TABS' ||
            node.classList.contains('predictive-search__tabs') ||
            node.hasAttribute('role') && node.getAttribute('role') === 'tablist' ||
            node.querySelector('x-tabs') ||
            node.querySelector('.predictive-search__tabs') ||
            node.querySelector('[role="tablist"]')
          )) {
            shouldUpdate = true;
          }
        });
        // Check if results were removed (might need to show loading state)
        mutation.removedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (
            node.id === 'easysearch-results-container' ||
            node.querySelector('x-tabs') ||
            node.querySelector('.predictive-search__tabs')
          )) {
            shouldUpdate = true;
          }
        });
      }
      if (mutation.type === 'attributes' && 
          (mutation.attributeName === 'style' || mutation.attributeName === 'class' || mutation.attributeName === 'value' || mutation.attributeName === 'aria-selected')) {
        const target = mutation.target;
        if (target.id === 'easysearch-results-container' ||
            target.id === 'easysearch-loading-state' ||
            target.id === 'easysearch-idle-state' ||
            target.classList.contains('easysearch-results-column') ||
            target.tagName === 'SELECT' ||
            target.tagName === 'INPUT' ||
            target.tagName === 'X-TABS' ||
            target.hasAttribute('aria-selected') ||
            target.hasAttribute('role') && target.getAttribute('role') === 'tablist') {
          shouldUpdate = true;
        }
      }
    });
    
    if (shouldUpdate) {
      setTimeout(updateResultsVisibility, 50);
    }
  });
  
  // Watch for form changes (make/year/model selection)
  function watchFormChanges() {
    const drawer = document.getElementById('easysearch-drawer');
    if (!drawer) return;
    
    const widgetContainer = drawer.querySelector('#easysearch-custom-form') || drawer.querySelector('.easysearch-wrapper');
    if (!widgetContainer) return;
    
    // Watch for changes on selects and inputs
    const formElements = widgetContainer.querySelectorAll('select, input');
    formElements.forEach(function(element) {
      element.addEventListener('change', function() {
        setTimeout(updateResultsVisibility, 100);
      });
      element.addEventListener('input', function() {
        setTimeout(updateResultsVisibility, 100);
      });
    });
    
    // Watch for listbox changes (aria-selected)
    const listboxOptions = widgetContainer.querySelectorAll('[role="option"], [aria-selected]');
    listboxOptions.forEach(function(option) {
      option.addEventListener('click', function() {
        setTimeout(updateResultsVisibility, 100);
      });
    });
  }
  
  // Start observing when drawer is available
  function startObserving() {
    const drawer = document.getElementById('easysearch-drawer');
    if (drawer) {
      observer.observe(drawer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class', 'value', 'aria-selected']
      });
      
      // Also watch the results container specifically
      const resultsContainer = document.getElementById('easysearch-results-container');
      if (resultsContainer) {
        observer.observe(resultsContainer, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['style', 'class']
        });
      }
      
      // Watch the loading state element
      const loadingState = document.getElementById('easysearch-loading-state');
      if (loadingState) {
        observer.observe(loadingState, {
          attributes: true,
          attributeFilter: ['style'],
          childList: true,
          subtree: true
        });
      }
      
      // Watch for form changes
      watchFormChanges();
      
      // Re-watch form changes when drawer opens
      drawer.addEventListener('dialog:open', function() {
        setTimeout(watchFormChanges, 200);
      });
    } else {
      setTimeout(startObserving, 500);
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserving);
  } else {
    startObserving();
  }
})();

/* ==================================================
   HIDE AFFIRM JAVASCRIPT CODE OUTPUT
   ================================================== */

(function() {
  function hideAffirmCodeOutput() {
    // Find all Affirm containers in product info
    const productInfo = document.querySelector('.product-info');
    if (!productInfo) return;
    
    const affirmContainers = productInfo.querySelectorAll('[class*="affirm"], [id*="affirm"]');
    
    affirmContainers.forEach(function(container) {
      // Walk through all child nodes
      const walker = document.createTreeWalker(
        container.parentNode || container,
        NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT,
        null,
        false
      );
      
      let node;
      while (node = walker.nextNode()) {
        // Check if it's a text node containing JavaScript code patterns
        if (node.nodeType === Node.TEXT_NODE) {
          const text = node.textContent.trim();
          if (text.includes('const appData') || 
              text.includes('promoAppConfig') || 
              text.includes('region_public_keys') ||
              text.includes('affirmPublicApiKeyProduct') ||
              (text.includes('const ') && text.includes('=') && text.length > 50)) {
            // Hide the parent element
            if (node.parentElement) {
              node.parentElement.style.display = 'none';
            }
          }
        }
        
        // Check if it's an element containing JavaScript code
        if (node.nodeType === Node.ELEMENT_NODE) {
          const text = node.textContent || '';
          if ((text.includes('const appData') || 
               text.includes('promoAppConfig') || 
               text.includes('region_public_keys')) &&
              !node.closest('script')) {
            // Don't hide if it's inside a script tag (those should execute)
            // But hide if it's displayed as text
            if (!node.tagName || node.tagName.toLowerCase() !== 'script') {
              node.style.display = 'none';
            }
          }
        }
      }
      
      // Also check siblings after Affirm containers
      let sibling = container.nextSibling;
      while (sibling) {
        if (sibling.nodeType === Node.ELEMENT_NODE) {
          const text = sibling.textContent || '';
          if (text.includes('const appData') || 
              text.includes('promoAppConfig') ||
              text.includes('region_public_keys')) {
            sibling.style.display = 'none';
          }
        } else if (sibling.nodeType === Node.TEXT_NODE) {
          const text = sibling.textContent.trim();
          if (text.includes('const appData') || 
              text.includes('promoAppConfig')) {
            if (sibling.parentElement) {
              sibling.parentElement.style.display = 'none';
            }
          }
        }
        sibling = sibling.nextSibling;
      }
    });
  }
  
  // Run immediately and also watch for dynamic content
  function initAffirmCodeHider() {
    hideAffirmCodeOutput();
    
    // Watch for new content being added (for dynamic Affirm widgets)
    const observer = new MutationObserver(function(mutations) {
      let shouldCheck = false;
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === Node.ELEMENT_NODE) {
              if (node.querySelector && (node.querySelector('[class*="affirm"]') || node.querySelector('[id*="affirm"]'))) {
                shouldCheck = true;
              }
              if (node.classList && (node.classList.toString().includes('affirm') || node.id && node.id.includes('affirm'))) {
                shouldCheck = true;
              }
            }
          });
        }
      });
      
      if (shouldCheck) {
        setTimeout(hideAffirmCodeOutput, 100);
      }
    });
    
    const productInfo = document.querySelector('.product-info');
    if (productInfo) {
      observer.observe(productInfo, {
        childList: true,
        subtree: true
      });
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAffirmCodeHider);
  } else {
    initAffirmCodeHider();
  }
})();

/* ==================================================
   BMW ACTIVE CRUISE CONTROL – THUMBNAIL + MODAL
   Show thumbnail when "Is your vehicle equipped with BMW Active Cruise Control" option is visible.
   ================================================== */
(function() {
  var ACC_IMAGE_URL = 'https://cdn.shopify.com/s/files/1/0428/2692/4184/files/BMW_G8X_M3-M4_Grille-active-cruise-control.jpg?v=1770760883';
  var MODAL_ID = 'acc-image-modal';
  var THUMB_ATTR = 'data-acc-thumbnail-injected';

  function createModal() {
    if (document.getElementById(MODAL_ID)) return document.getElementById(MODAL_ID);
    var dialog = document.createElement('dialog');
    dialog.id = MODAL_ID;
    dialog.setAttribute('aria-label', 'BMW Active Cruise Control – grille reference');
    dialog.className = 'acc-image-modal';
    dialog.innerHTML =
      '<div class="acc-image-modal__backdrop" data-acc-close></div>' +
      '<div class="acc-image-modal__content">' +
        '<button type="button" class="acc-image-modal__close" data-acc-close aria-label="Close">×</button>' +
        '<img src="' + ACC_IMAGE_URL + '" alt="BMW G8X M3/M4 grille with Active Cruise Control sensor location" class="acc-image-modal__img" />' +
      '</div>';
    document.body.appendChild(dialog);

    dialog.querySelectorAll('[data-acc-close]').forEach(function(btn) {
      btn.addEventListener('click', function() { dialog.close(); });
    });
    dialog.addEventListener('click', function(e) {
      if (e.target === dialog) dialog.close();
    });
    dialog.addEventListener('cancel', function() { dialog.close(); });
    return dialog;
  }

  function openModal() {
    var dialog = document.getElementById(MODAL_ID) || createModal();
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  function tryInjectAccThumbnail() {
    var container = document.getElementById('infiniteoptions-container');
    if (!container || container.getAttribute(THUMB_ATTR) === 'true') return;

    var groups = container.querySelectorAll('[role="group"]');
    for (var g = 0; g < groups.length; g++) {
      var group = groups[g];
      var text = (group.textContent || '').toLowerCase();
      if (text.indexOf('active cruise control') === -1 && text.indexOf('bmw active cruise') === -1) continue;

      var optionsSpan = group.querySelector(':scope > span');
      if (!optionsSpan) continue;

      var headerPart = null;
      for (var i = 0; i < group.children.length; i++) {
        if (group.children[i] !== optionsSpan) {
          headerPart = group.children[i];
          break;
        }
      }
      if (!headerPart) continue;

      // Add tooltip icon to question label
      var questionLabel = headerPart.querySelector('label');
      if (questionLabel) {
        var tooltipIcon = document.createElement('button');
        tooltipIcon.type = 'button';
        tooltipIcon.className = 'acc-tooltip-icon';
        tooltipIcon.setAttribute('title', 'Not sure? Click to see where the Active Cruise Control sensor is located on your grille.');
        tooltipIcon.setAttribute('aria-label', 'View Active Cruise Control sensor location');
        tooltipIcon.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/><text x="8" y="11.5" font-size="11" font-weight="600" fill="currentColor" text-anchor="middle" dominant-baseline="middle">?</text></svg>';
        tooltipIcon.addEventListener('click', function(e) {
          e.preventDefault();
          openModal();
        });
        questionLabel.appendChild(tooltipIcon);
      }

      // Create thumbnail and add as first column in options row
      var thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'acc-thumbnail-trigger';
      thumb.setAttribute('aria-label', 'View BMW Active Cruise Control reference image');
      thumb.innerHTML = '<img src="' + ACC_IMAGE_URL + '" alt="" width="72" height="72" />';
      thumb.addEventListener('click', function(e) {
        e.preventDefault();
        openModal();
      });
      
      optionsSpan.insertBefore(thumb, optionsSpan.firstChild);
      optionsSpan.classList.add('acc-options-with-thumbnail');

      if (!container.querySelector('.infiniteoptions-thumbnail-instruction')) {
        var instruction = document.createElement('p');
        instruction.className = 'infiniteoptions-thumbnail-instruction';
        instruction.textContent = 'Click the thumbnail to view full image.';
        container.appendChild(instruction);
      }

      container.setAttribute(THUMB_ATTR, 'true');
      return;
    }
  }

  function run() {
    tryInjectAccThumbnail();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  setTimeout(run, 600);
  setTimeout(run, 1800);

  var container = document.getElementById('infiniteoptions-container');
  if (container) {
    var mo = new MutationObserver(function() { tryInjectAccThumbnail(); });
    mo.observe(container, { childList: true, subtree: true });
  }
})();

/* ==================================================
   OPTIONAL GRILLE MESH – THUMBNAIL + MODAL
   Show thumbnail when "Optional Grille Mesh +$165" option is visible.
   ================================================== */
(function() {
  var GRILLE_MESH_IMAGE_URL = 'https://vorsteiner.com/cdn/shop/products/grille-1.png?v=1764812282&width=800';
  var MODAL_ID = 'grille-mesh-image-modal';
  var THUMB_ATTR = 'data-grille-mesh-thumbnail-injected';

  function createModal() {
    if (document.getElementById(MODAL_ID)) return document.getElementById(MODAL_ID);
    var dialog = document.createElement('dialog');
    dialog.id = MODAL_ID;
    dialog.setAttribute('aria-label', 'Optional Grille Mesh – reference');
    dialog.className = 'grille-mesh-image-modal';
    dialog.innerHTML =
      '<div class="grille-mesh-image-modal__backdrop" data-grille-mesh-close></div>' +
      '<div class="grille-mesh-image-modal__content">' +
        '<button type="button" class="grille-mesh-image-modal__close" data-grille-mesh-close aria-label="Close">×</button>' +
        '<img src="' + GRILLE_MESH_IMAGE_URL + '" alt="Optional Grille Mesh reference" class="grille-mesh-image-modal__img" />' +
      '</div>';
    document.body.appendChild(dialog);

    dialog.querySelectorAll('[data-grille-mesh-close]').forEach(function(btn) {
      btn.addEventListener('click', function() { dialog.close(); });
    });
    dialog.addEventListener('click', function(e) {
      if (e.target === dialog) dialog.close();
    });
    dialog.addEventListener('cancel', function() { dialog.close(); });
    return dialog;
  }

  function openModal() {
    var dialog = document.getElementById(MODAL_ID) || createModal();
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  function tryInjectGrilleMeshThumbnail() {
    var container = document.getElementById('infiniteoptions-container');
    if (!container || container.getAttribute(THUMB_ATTR) === 'true') return;

    var groups = container.querySelectorAll('[role="group"]');
    for (var g = 0; g < groups.length; g++) {
      var group = groups[g];
      var text = (group.textContent || '').toLowerCase();
      if (text.indexOf('optional grille mesh') === -1) continue;

      var optionsSpan = group.querySelector(':scope > span');
      if (!optionsSpan) continue;

      var headerPart = null;
      for (var i = 0; i < group.children.length; i++) {
        if (group.children[i] !== optionsSpan) {
          headerPart = group.children[i];
          break;
        }
      }
      if (!headerPart) continue;

      // Create thumbnail and add as first column in options row
      var thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'grille-mesh-thumbnail-trigger';
      thumb.setAttribute('aria-label', 'View Optional Grille Mesh reference image');
      thumb.innerHTML = '<img src="' + GRILLE_MESH_IMAGE_URL + '" alt="" width="72" height="72" />';
      thumb.addEventListener('click', function(e) {
        e.preventDefault();
        openModal();
      });
      
      optionsSpan.insertBefore(thumb, optionsSpan.firstChild);
      optionsSpan.classList.add('grille-mesh-options-with-thumbnail');

      if (!container.querySelector('.infiniteoptions-thumbnail-instruction')) {
        var instruction = document.createElement('p');
        instruction.className = 'infiniteoptions-thumbnail-instruction';
        instruction.textContent = 'Click the thumbnail to view full image.';
        container.appendChild(instruction);
      }

      container.setAttribute(THUMB_ATTR, 'true');
      return;
    }
  }

  function run() {
    tryInjectGrilleMeshThumbnail();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  setTimeout(run, 600);
  setTimeout(run, 1800);

  var container = document.getElementById('infiniteoptions-container');
  if (container) {
    var mo = new MutationObserver(function() { tryInjectGrilleMeshThumbnail(); });
    mo.observe(container, { childList: true, subtree: true });
  }
})();

/* ==================================================
   HOOD PRIMER OPTIONS – THUMBNAIL + MODAL
   Show thumbnails when "Select Your Primer Option" is visible.
   Each option has its own thumbnail; clicking opens modal with that image.
   Unique to this option group – no leakage to ACC or Grille Mesh.
   ================================================== */
(function() {
  var PRIMED_IMAGE_URL = 'https://vorsteiner.com/cdn/shop/files/BMW-E46-M3_V20-Aero_Hood_2.jpg?v=1756507193&width=1400';
  var FULL_EXPOSED_IMAGE_URL = 'https://cdn.shopify.com/s/files/1/0428/2692/4184/files/BMW-E46-M3_V20-Aero_Hood_exposed-Carbon_2.jpg?v=1773767164';
  var MODAL_ID = 'primer-image-modal';
  var THUMB_ATTR = 'data-primer-thumbnail-injected';

  function createModal() {
    if (document.getElementById(MODAL_ID)) return document.getElementById(MODAL_ID);
    var dialog = document.createElement('dialog');
    dialog.id = MODAL_ID;
    dialog.setAttribute('aria-label', 'Hood Primer Option – reference image');
    dialog.className = 'primer-image-modal';
    dialog.innerHTML =
      '<div class="primer-image-modal__backdrop" data-primer-close></div>' +
      '<div class="primer-image-modal__content">' +
        '<button type="button" class="primer-image-modal__close" data-primer-close aria-label="Close">×</button>' +
        '<img src="" alt="Hood primer option reference" class="primer-image-modal__img" />' +
      '</div>';
    document.body.appendChild(dialog);

    dialog.querySelectorAll('[data-primer-close]').forEach(function(btn) {
      btn.addEventListener('click', function() { dialog.close(); });
    });
    dialog.addEventListener('click', function(e) {
      if (e.target === dialog) dialog.close();
    });
    dialog.addEventListener('cancel', function() { dialog.close(); });
    return dialog;
  }

  function openModal(imageUrl) {
    var dialog = document.getElementById(MODAL_ID) || createModal();
    var img = dialog.querySelector('.primer-image-modal__img');
    if (img && imageUrl) img.src = imageUrl;
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
  }

  function tryInjectPrimerThumbnails() {
    var container = document.getElementById('infiniteoptions-container');
    if (!container || container.getAttribute(THUMB_ATTR) === 'true') return;

    var groups = container.querySelectorAll('[role="group"]');
    for (var g = 0; g < groups.length; g++) {
      var group = groups[g];
      var text = (group.textContent || '').toLowerCase();
      if (text.indexOf('primer option') === -1 && text.indexOf('hood primer') === -1) continue;

      var optionsSpan = group.querySelector(':scope > span');
      if (!optionsSpan) continue;

      var thumb1 = document.createElement('button');
      thumb1.type = 'button';
      thumb1.className = 'primer-thumbnail-trigger';
      thumb1.setAttribute('aria-label', 'View Primed Top – Fender vents exposed carbon');
      thumb1.innerHTML = '<img src="' + PRIMED_IMAGE_URL + '" alt="" width="72" height="72" />';
      thumb1.addEventListener('click', function(e) {
        e.preventDefault();
        openModal(PRIMED_IMAGE_URL);
      });

      var thumb2 = document.createElement('button');
      thumb2.type = 'button';
      thumb2.className = 'primer-thumbnail-trigger';
      thumb2.setAttribute('aria-label', 'View Full Exposed Carbon');
      thumb2.innerHTML = '<img src="' + FULL_EXPOSED_IMAGE_URL + '" alt="" width="72" height="72" />';
      thumb2.addEventListener('click', function(e) {
        e.preventDefault();
        openModal(FULL_EXPOSED_IMAGE_URL);
      });

      var labels = optionsSpan.querySelectorAll(':scope > label');
      if (labels.length >= 2) {
        optionsSpan.insertBefore(thumb1, labels[0]);
        optionsSpan.insertBefore(thumb2, labels[1]);
      } else {
        optionsSpan.insertBefore(thumb2, optionsSpan.firstChild);
        optionsSpan.insertBefore(thumb1, optionsSpan.firstChild);
      }
      optionsSpan.classList.add('primer-options-with-thumbnail');

      if (!container.querySelector('.infiniteoptions-thumbnail-instruction')) {
        var instruction = document.createElement('p');
        instruction.className = 'infiniteoptions-thumbnail-instruction';
        instruction.textContent = 'Click the thumbnail to view full image.';
        container.appendChild(instruction);
      }

      container.setAttribute(THUMB_ATTR, 'true');
      return;
    }
  }

  function run() {
    tryInjectPrimerThumbnails();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  setTimeout(run, 600);
  setTimeout(run, 1800);

  var container = document.getElementById('infiniteoptions-container');
  if (container) {
    var mo = new MutationObserver(function() { tryInjectPrimerThumbnails(); });
    mo.observe(container, { childList: true, subtree: true });
  }
})();

/* Sticky header: frosted glass on scroll (see Header section "Frosted glass when scrolled") */
(function() {
  var THRESHOLD_PX = 10;
  var scrollBound = false;

  function updateStickyGlassScroll() {
    var headers = document.querySelectorAll('store-header.header[glass-on-scroll]');
    var y = window.scrollY || document.documentElement.scrollTop || 0;
    headers.forEach(function(el) {
      el.classList.toggle('is-scrolled', y > THRESHOLD_PX);
    });
  }

  function bindScrollOnce() {
    if (scrollBound) {
      updateStickyGlassScroll();
      return;
    }
    if (!document.querySelector('store-header.header[glass-on-scroll]')) return;
    scrollBound = true;
    window.addEventListener('scroll', updateStickyGlassScroll, { passive: true });
    window.addEventListener('pageshow', function(ev) {
      if (ev.persisted) updateStickyGlassScroll();
    });
  }

  function init() {
    updateStickyGlassScroll();
    bindScrollOnce();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function(ev) {
    if (ev && ev.target && ev.target.querySelector && ev.target.querySelector('store-header.header[glass-on-scroll]')) {
      init();
    }
  });
})();

/* ==================================================
   CART ADD – graceful handling for 429 / non-JSON responses
   Shopify returns HTML on rate-limit; theme.js expects JSON.
   ================================================== */
(function () {
  var nativeFetch = window.fetch;

  window.fetch = function (input, init) {
    return nativeFetch.apply(this, arguments).then(function (response) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';

      if (url.indexOf('cart/add.js') === -1 || response.ok) {
        return response;
      }

      var contentType = response.headers.get('content-type') || '';

      if (contentType.indexOf('application/json') !== -1) {
        return response;
      }

      var message = response.status === 429
        ? 'Too many requests. Please wait a moment and try again.'
        : 'Unable to add to cart. Please try again.';

      return new Response(JSON.stringify({ description: message, message: message }), {
        status: response.status,
        statusText: response.statusText,
        headers: { 'Content-Type': 'application/json' }
      });
    });
  };
})();

/* ==================================================
   CUSTOM BOTTOM BAR
   ================================================== */
(function () {
  var STORAGE_PREFIX = 'vorsteiner-custom-bottom-bar:';
  var IDENTITY_SECTION = 'custom-bottom-bar-identity';

  function normalizeTag(tag) {
    return String(tag || '').trim().toLowerCase();
  }

  function getDismissKey(bar) {
    var sectionId = bar.getAttribute('data-section-id') || 'default';
    var message = bar.querySelector('.custom-bottom-bar__message');
    var messageText = message ? message.textContent.trim() : '';
    return STORAGE_PREFIX + sectionId + ':' + messageText.slice(0, 120);
  }

  function getStorage(bar) {
    return bar.hasAttribute('data-remember-dismiss') ? window.localStorage : window.sessionStorage;
  }

  function updateReservedSpace(bar) {
    if (!bar.hasAttribute('data-reserve-space') || bar.hidden) {
      document.documentElement.style.setProperty('--custom-bottom-bar-height', '0px');
      return;
    }

    var height = Math.ceil(bar.getBoundingClientRect().height);
    document.documentElement.style.setProperty('--custom-bottom-bar-height', height + 'px');
  }

  function hideBar(bar) {
    bar.hidden = true;
    updateReservedSpace(bar);
  }

  function showBar(bar) {
    bar.hidden = false;
    updateReservedSpace(bar);
  }

  function applyHeadingPlaceholders(bar, identity) {
    var heading = bar.querySelector('[data-custom-bottom-bar-heading]');
    if (!heading || !identity) {
      return;
    }

    var text = heading.textContent;
    text = text.replace(/\[first_name\]/g, identity.firstName || '');
    text = text.replace(/\[last_name\]/g, identity.lastName || '');
    text = text.replace(/\[company\]/g, identity.company || '');
    heading.textContent = text;
  }

  function matchesVisibility(bar, identity) {
    var visibility = bar.getAttribute('data-visibility') || 'all';
    var targetTag = normalizeTag(bar.getAttribute('data-customer-tag'));
    var homepageOnly = bar.getAttribute('data-homepage-only') === 'true';
    var isHomepage = document.body.classList.contains('template-index') || window.location.pathname === '/';

    if (homepageOnly && !isHomepage) {
      return false;
    }

    if (visibility === 'all') {
      return true;
    }

    if (visibility === 'logged_out') {
      return !identity || !identity.loggedIn;
    }

    if (!identity || !identity.loggedIn) {
      return false;
    }

    if (visibility === 'logged_in') {
      return true;
    }

    if (visibility === 'customer_tag') {
      if (!targetTag) {
        return false;
      }

      return (identity.tags || []).some(function (tag) {
        return normalizeTag(tag) === targetTag;
      });
    }

    return false;
  }

  function fetchCustomerIdentity() {
    var url = window.location.pathname + '?sections=' + IDENTITY_SECTION;

    return fetch(url, {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Identity request failed');
        }
        return response.json();
      })
      .then(function (payload) {
        var sectionHtml = payload && payload[IDENTITY_SECTION];
        if (!sectionHtml) {
          return null;
        }

        return JSON.parse(sectionHtml.trim());
      })
      .catch(function () {
        return null;
      });
  }

  function isShopifyAccountSignedIn() {
    var account = document.querySelector('shopify-account');
    if (!account || !account.shadowRoot) {
      return false;
    }

    return !!account.shadowRoot.querySelector('[part~="signed-in-avatar"], [part="signed-in-avatar"]');
  }

  function setupBarObservers(bar) {
    if (bar.__customBottomBarInitialized) {
      return;
    }

    bar.__customBottomBarInitialized = true;

    if (typeof ResizeObserver !== 'undefined') {
      var observer = new ResizeObserver(function () {
        updateReservedSpace(bar);
      });
      observer.observe(bar);
    }

    window.addEventListener('resize', function () {
      updateReservedSpace(bar);
    });
  }

  function initVisibleBar(bar) {
    if (bar.hasAttribute('data-dismissible')) {
      var storage = getStorage(bar);
      if (storage.getItem(getDismissKey(bar)) === 'dismissed') {
        hideBar(bar);
        setupBarObservers(bar);
        return;
      }
    }

    showBar(bar);
    setupBarObservers(bar);
  }

  function resolveDeferredVisibility(bar, attempt) {
    attempt = attempt || 0;

    return fetchCustomerIdentity().then(function (identity) {
      if ((!identity || !identity.loggedIn) && isShopifyAccountSignedIn() && attempt < 2) {
        return new Promise(function (resolve) {
          window.setTimeout(function () {
            resolve(resolveDeferredVisibility(bar, attempt + 1));
          }, attempt === 0 ? 400 : 1200);
        });
      }

      if (matchesVisibility(bar, identity)) {
        applyHeadingPlaceholders(bar, identity);
        bar.removeAttribute('data-defer-visibility');
        initVisibleBar(bar);
      } else {
        hideBar(bar);
        setupBarObservers(bar);
      }
    });
  }

  function initBar(bar) {
    if (bar.hasAttribute('data-defer-visibility')) {
      hideBar(bar);
      resolveDeferredVisibility(bar, 0);
      return;
    }

    initVisibleBar(bar);
  }

  class CustomBottomBar extends HTMLElement {
    connectedCallback() {
      initBar(this);

      this.addEventListener('click', function (event) {
        var dismissButton = event.target.closest('[data-action="dismiss"]');
        if (!dismissButton || !this.hasAttribute('data-dismissible')) {
          return;
        }

        getStorage(this).setItem(getDismissKey(this), 'dismissed');
        hideBar(this);
      }.bind(this));

      if (window.Shopify && Shopify.designMode) {
        var section = this.closest('.shopify-section');
        if (section) {
          section.addEventListener('shopify:section:select', function () {
            showBar(this);
          }.bind(this));
        }
      }
    }
  }

  if (!window.customElements.get('custom-bottom-bar')) {
    window.customElements.define('custom-bottom-bar', CustomBottomBar);
  }

  document.documentElement.style.setProperty('--custom-bottom-bar-height', '0px');
})();
